import React from 'react'
import { reduxForm } from 'redux-form'

import Card from '../../../Shared/Card'
import Button from '../../../Shared/Button'
import ViewSelector from './ViewSelector'

import styles from './ViewSetup.module.css'

const FORM_NAME = 'viewSetupForm'

const Form = function ViewSetupForm({ database, handleSubmit, submitting }) {
  return (
    <Card
      component="form"
      actions={<Button loading={submitting}>Create Views</Button>}
      onSubmit={handleSubmit}
    >
      <h1>
        Great, we were able to connect
        <br />
        Now let’s create some views
      </h1>
      <p className="subtitle">
        Views allow you to see the records in your database. You can always add,
        remove, and customize these later.
      </p>
      <div className={styles.accordions}>
        {database.schema.map(table => (
          <ViewSelector form={FORM_NAME} table={table} field={table.name} />
        ))}
      </div>
    </Card>
  )
}

export default reduxForm({
  form: FORM_NAME,
})(Form)
